import axios from 'axios'

import { createCollection } from './collection'

export default createCollection({
  fetchAll: {
    request: () => axios.get('/static/mock-data/news.json'),
    processResponse (response) {
      return response.data.data.reduce((news, entry) => {
        news.ids.push(entry.id)
        news.entities[entry.id] = entry
        return news
      }, { ids: [], entities: {}, loaded: true })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/news.js